import React from "react";
// components
import Card from "../../components/Cards/DashboardCards/Card";
import {
  mainContainerLayout1,
  mainContainerLayout2,
  mainContainerLayout3,
  leftLayout,
} from "./Api/DashboardCard";
import List from "../../components/Listings/List";
import CardSample from "./components/CardSample/CardSample";
import CalendarComponent from "./components/CalendarComponent/CalendarComponent";
import DiaryComponent from "./components/DiaryComponent/DiaryComponent";
import WorkFlowComponent from "./components/WorkFlowComponent/WorkFlowComponent";
const cardComponent = {
  List: List,
  Card: CardSample,
  Calendar: CalendarComponent,
  Diary: DiaryComponent,
  WorkFlow: WorkFlowComponent,
};

export default function Dashboard(props) {
  const getComponent = (card) => {
    const { type } = card;
    if (cardComponent[type]) {
      const Component = cardComponent[type];
      return <Component card={card} />;
    }
  };
  return (
    <>
      <div className={"container-fluid"}>
        {/* main container */}
        <div className={"row"}>
          <div className={"col-md-9 pl-0"}>
            <div className={"row mt-2"}>
              {mainContainerLayout1.map((card) => {
                return <Card key={card.title} card={card} />;
              })}
            </div>
            <div className={"row mt-2"}>
              {mainContainerLayout2.map((card) => {
                return (
                  <Card key={card.title} card={card}>
                    {" "}
                    {getComponent(card)}{" "}
                  </Card>
                );
              })}
            </div>
            <div className={"row mt-2"}>
              {mainContainerLayout3.map((card) => {
                return (
                  <Card key={card.title} card={card}>
                    {getComponent(card)}
                  </Card>
                );
              })}
            </div>
          </div>
          {/* left container */}
          <div className={"col-md-3"}>
            <div className={"row mt-2"}>
              {leftLayout.map((card) => {
                return (
                  <Card key={card.title} card={card}>
                    {" "}
                    {getComponent(card)}{" "}
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
